import { useBrowseLayoutDefinedFilteredComponentsQuery } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useBrowseLayoutDefinedFilteredComponentsQuery/useBrowseLayoutDefinedFilteredComponentsQuery";

export const useIsBrowseFpsLoadedAndHasNoResults = () => {
  const { isError, isFetching, data } =
    useBrowseLayoutDefinedFilteredComponentsQuery();

  const fpsComponents = data?.components;

  if (isFetching || fpsComponents === undefined) {
    return false;
  }

  if (isError) {
    return true;
  }

  const fpsHasResults = fpsComponents.some(
    (component) =>
      component.is_required_for_interactivity &&
      (component.grid_component || component.tile_wrapper_component)
  );

  return !fpsHasResults;
};
